function _instanceof(left, right) {
  if (
    right != null &&
    typeof Symbol !== "undefined" &&
    right[Symbol.hasInstance]
  ) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function showCartLoaders() {
  document.querySelector("[data-animated-cart-loader]").classList.add("show");
  document.querySelector("[data-cart-loading-spinner]").classList.add("show");
}

function hideCartLoaders() {
  document.querySelector("[data-animated-cart-loader]").classList.remove("show");
  document.querySelector("[data-cart-loading-spinner]").classList.remove("show");
}

/** Instant drawer UI; Shopify sync is deferred (wonderful-cart session or fallback below). */
var CLASSIC_CART_AJAX_QUERY_DEFAULT = false;

var classicDrawerShopifyFlushTimer = null;
var classicDrawerPendingUpdates = {};

function isOptimisticCartMutation(item) {
  return item && item.ajaxQuery === false;
}

function scheduleClassicDrawerShopifyPush(variantId, quantity) {
  if (!window.__WONDERFUL_CLASSIC_CART_PUSH_SKIP__) {
    window.dispatchEvent(
      new CustomEvent("wonderful:classic-cart-item-updated", {
        detail: {
          variantId: String(variantId || ""),
          quantity: Number(quantity) || 0,
        },
      })
    );
  }
  if (window.__WONDERFUL_SESSION_CART_SYNC__) return;
  classicDrawerPendingUpdates[String(variantId)] = Number(quantity) || 0;
  if (classicDrawerShopifyFlushTimer) clearTimeout(classicDrawerShopifyFlushTimer);
  classicDrawerShopifyFlushTimer = setTimeout(function () {
    classicDrawerShopifyFlushTimer = null;
    var updates = Object.assign({}, classicDrawerPendingUpdates);
    classicDrawerPendingUpdates = {};
    if (Object.keys(updates).length === 0) return;
    var sendUpdate = function (attributesPatch) {
      var body = { updates: updates };
      if (attributesPatch) body.attributes = attributesPatch;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(body),
      })
        .then(function (res) {
          if (res.ok && attributesPatch && window.WonderfulExperienceLog) {
            window.WonderfulExperienceLog.markFlushed();
          }
        })
        .catch(function () {});
    };
    if (window.WonderfulExperienceLog) {
      window.WonderfulExperienceLog.getPendingAttributesPatch()
        .then(sendUpdate)
        .catch(function () {
          sendUpdate(null);
        });
    } else {
      sendUpdate(null);
    }
  }, 400);
}

var CartDrawer = /*#__PURE__*/ (function () {
  "use strict";

  function CartDrawer(
    cartDrawer,
    itemTemplate,
    gridView,
    listView,
    listButton,
    gridButton
  ) {
    _classCallCheck(this, CartDrawer);

    this.SELLING_PLAN_ID = "3040903353";

    this.drawer = document.querySelector(cartDrawer);
    this.item = document.querySelector(itemTemplate);
    this.grid = document.querySelector(gridView);
    this.list = document.querySelector(listView);
    this.listButton = document.querySelector(listButton);
    this.gridButton = document.querySelector(gridButton);
    this.awaitingAsyncAction = false; 
    this.isMonthlySubscriptionActive = false;
    this._optimisticSeqByVariant = {};
  }

  _createClass(CartDrawer, [
    {
      key: "showCartLoaders",
      value: showCartLoaders,
    },
    {
      key: "hideCartLoaders",
      value: hideCartLoaders,
    },
    {
      key: "checkDrawer",
      value: function checkDrawer() {
        if (this.drawer.classList.contains("active")) {
          return true;
        } else {
          return false;
        }
      },
    },
    {
      key: "checkGrid",
      value: function checkGrid() {
        if (this.grid && this.grid.classList.contains("hide")) {
          return false;
        } else {
          return true;
        }
      },
    },
    {
      key: "checkList",
      value: function checkList() {
        if (this.list.classList.contains("hide")) {
          return false;
        } else {
          return true;
        }
      },
    },
    {
      key: "setMonthlySubscriptionState",
      value: async function setMonthlySubscriptionState() {
        if (await allItemsAreMonthly()) {
          this.isMonthlySubscriptionActive = true;
        } else {
          this.isMonthlySubscriptionActive = false;
        }
      },
    },
    {
      key: "openDrawer",
      value: function openDrawer() {
        // enable or disable overlay about empty cart
        //this.changeDrawerStatus();
        this.checkHeaderHeight();
        this.drawer.classList.add("active");
        document.body.classList.add("cart-drawer-active");

        //move cart grid to left on cartdrawer open
        if (
          $(".collection_grid_wrapper").hasClass(
            "collection_grid_move_on_cart_open"
          )
        ) {
          var cart_grid_offset_left = document.querySelector(
            ".collection_grid_wrapper"
          ).offsetLeft;
          $(".collection_grid_wrapper > .grid").css(
            "transform",
            "translateX(-" + cart_grid_offset_left + "px)"
          );
        }
      },
    },
    {
      key: "openList",
      value: function openList() {
        // open the list layout
        if (!this.checkList()) {
          this.list.classList.remove("hide");
          this.grid.classList.add("hide");
          this.list.parentElement.classList.remove("stretch-bg");
          this.closeDrawer();
        }
      },
    },
    {
      key: "openGrid",
      value: function openGrid() {
        // open the grid layout
        if (!this.checkGrid()) {
          this.grid.classList.remove("hide");
          this.list.classList.add("hide");
          this.list.parentElement.classList.add("stretch-bg");
          if (window.innerWidth > 1160) {
            //this.openDrawer();
          }
        }
      },
    },
    {
      key: "closeDrawer",
      value: function closeDrawer() {
        this.drawer.classList.remove("active");
        document.body.classList.remove("cart-drawer-active");
        if (
          $(".collection_grid_wrapper").hasClass(
            "collection_grid_move_on_cart_open"
          )
        ) {
          $(".collection_grid_wrapper > .grid").css(
            "transform",
            "translateX(0)"
          );

          $(".collection_grid_wrapper > .grid").css("transform", "unset");
        }

        if (window.location.hash == "#cart") {
          //window.location.hash = '';
          var url_without_hash = window.location.href.substr(
            0,
            window.location.href.indexOf("#")
          );
          history.pushState("data", "", url_without_hash);
        }
      },
    },
    {
      key: "changeDrawerStatus",
      value: function changeDrawerStatus() {
        var emptyCartOverlay = document.querySelector("#empty-cart-drawer"),
          clearCart = document.querySelector("#clear-cart-items"),
          cartDrawerItemsCount =
            this.drawer.querySelectorAll(".item__wrapper").length;
 
        if (cartDrawerItemsCount > 0) {
          emptyCartOverlay.classList.remove("active");
          clearCart.classList.add("active");
          document.getElementById("collection__goto_checkout")?.classList.remove("d-none");
        } else {
          emptyCartOverlay.classList.add("active");
          clearCart.classList.remove("active");
          if (!document.getElementById("collection__goto_checkout")?.classList.contains("d-none")) {
            document.getElementById("collection__goto_checkout")?.classList.add("d-none");
          }
        }
      },
    },
    {
      key: "checkHeaderHeight",
      value: function checkHeaderHeight() {
        var header = document.querySelector("#shopify-section-header"),
          headerHeight = header.offsetHeight;
        this.drawer.querySelector("#cart-drawer__cart").style.height =
          "calc(100% - ".concat(headerHeight - 1, "px)");
      },
    },
    {
      key: "addToDrawer",
      value: 
      // function addToDrawer(item) {
      //   // console.log("addToDrawer: ", item);

      //   var itemInput = document.querySelectorAll(
      //     'input.quantity-detector[data-id="'.concat(item.productId, '"]')
      //   );
      //   var itemsPlace = this.drawer.querySelector(".cart-drawer__cart-items"),
      //     newItem = this.renderTemplateData(this.item.innerHTML, item),
      //     itemInCart = this.drawer.querySelector(
      //       '.item__wrapper[data-id="'.concat(item.productId, '"]')
      //     ); // check for empty value
      //   if (item.productCount.length == 0) {
      //     item.productCount = null;
      //   } // checking for existing current item in the cart

      //   var isInputFieldInactiveAndZero = function (input) {
      //     return (
      //       input !== document.activeElement &&
      //       (input.value === "" || input.value <= 0)
      //     );
      //   };

      //   for (var i = 0; i < itemInput.length; i++) {
      //     itemInput[i].addEventListener(
      //       "blur",
      //       function (event) {
      //         if (isInputFieldInactiveAndZero(event.target)) {
                
                
      //           this.removeFromDrawer(item);
                
      //           // You may need to use a reference to "this" depending on your context.
      //         }
      //       }.bind(this)
      //     );
      //   }

      //   if (typeof itemInCart != "undefined" && itemInCart != null) {
      //     // if an item in the cart - checking quantity. If 0 - removing item else update item count and price
      //     if (item.productCount >= 0) {

      //       // this will only fire when the action is 'update' or when the user types in the input field
      //       // see input event listeners below
      //       if (item.action == "update") {
      //         let currentProductQuantity = parseInt(itemInCart.querySelector(".item__image-count").innerText);
      //         if (isNaN(currentProductQuantity)) currentProductQuantity = 0;
      //         let newProductQuantity = parseInt(item.productCount);
              
      //         if (currentProductQuantity > newProductQuantity) {
      //           this.removeImageAnimation(item.productImage);
      //         } else if (currentProductQuantity < newProductQuantity) {
      //           this.addImageAnimation(item.productImage);
      //         }
      //       }

      //       this.updateItemPrice(item);
      //       this.updateItemDrawerQty(item);

      //       if (item.productCount == 0) {
      //         this.removeFromDrawer(item);
      //       }

      //       if (item.action == "add") {
      //         this.addImageAnimation(item.productImage);
      //       } else if (item.action == "remove") {
      //         this.removeImageAnimation(item.productImage);
      //       }
      //     } else {
      //       if (item.type !== "modal" || isInputFieldInactiveAndZero()) {
              
                
      //         this.removeFromDrawer(item);
      //         this.removeImageAnimation(item.productImage);
      //       }
      //     }

      //     // maybe move this above to be the first one in the conditional in order to make 
      //     // sure this is executed no matter what action fails to be executed within the custom cart drawer
      //     this.changeCartItem(
      //       item.productId,
      //       item.productCount,
      //       "change",
      //       item.ajaxQuery
      //     );
      //   } else if (item.productCount > 0) {
      //     // add animation for a product image
      //     if (item.itemAnimation) {
      //       if (item.action == "add") {
      //         this.addImageAnimation(item.productImage);
      //       } else if (item.action == "remove") {
      //         this.removeImageAnimation(item.productImage);
      //       }
      //     }
      //     // if an item is in the cart - rendering item and pushing to the cart

      //     itemsPlace.insertAdjacentHTML("afterbegin", newItem);
      //     this.changeCartItem(
      //       item.productId,
      //       item.productCount,
      //       "add",
      //       item.ajaxQuery
      //     );
      //     initCartEvent(item);
      //   } // set a qty value

      //   this.updateSubtotalAndCartNumber();

      //   this.setInputValue(item); // opening drawer if not opened and not mobile version

      //   var addedItem = {
      //     productId: item.productId,
      //     productTitle: item.productTitle,
      //     productCategory: item.productCategory,
      //     productImage: item.productImage,
      //     productPrice: item.productPrice,
      //   };
      //   // _learnq.push(['track', 'Added to Cart', addedItem]);

      //   if (
      //     window.innerWidth > 1160 &&
      //     !this.checkDrawer() &&
      //     item.openCartDrawer
      //   ) {
      //     this.openDrawer();

      //     if (this.checkGrid()) {
      //       this.moveGridToLeft();
      //     }
      //   }
      // },
      async function addToDrawer(item, skipOnInputEvents = false) {
        var optimistic = isOptimisticCartMutation(item);

        if (!optimistic && this.awaitingAsyncAction) {
          setTimeout(() => {
            this.addToDrawer(item, skipOnInputEvents);
          }, 500);
          return;
        }

        if (!optimistic) this.awaitingAsyncAction = true;

        var optimisticVariantId = String(item.productId || "");
        var optimisticMySeq = null;
        if (optimistic) {
          optimisticMySeq =
            (this._optimisticSeqByVariant[optimisticVariantId] || 0) + 1;
          this._optimisticSeqByVariant[optimisticVariantId] = optimisticMySeq;
        }

        var isStaleOptimisticMutation = function () {
          if (!optimistic || optimisticMySeq == null) return false;
          return (
            this._optimisticSeqByVariant[optimisticVariantId] !== optimisticMySeq
          );
        }.bind(this);

        try {
        // console.log("addToDrawer: ", item);

        if (item.productCount != null && item.productCount !== "") {
          var __qtyParsed = parseInt(String(item.productCount), 10);
          item.productCount = isNaN(__qtyParsed) ? 0 : __qtyParsed;
        } else {
          item.productCount = null;
        }

        var itemInput = document.querySelectorAll(
          `input.quantity-detector[data-id="${item.productId}"]`
        );
        var itemsPlace = this.drawer.querySelector(".cart-drawer__cart-items"),
          newItem = this.renderTemplateData(this.item.innerHTML, item),
          itemInCart = this.drawer.querySelector(
            `.item__wrapper[data-id="${item.productId}"]`
          );

        // Source-attribution log: only for genuine classic-UI mutations, not the
        // chat-cart visual mirror (which sets this flag while it calls addToDrawer
        // to reflect its own — already separately logged — mutations in the drawer).
        var __productLabelForLog = item.productTitle || item.productDataTitle || "";
        // addToDrawer() is shared code for every quantity-detector/select on the site (the
        // featured-collections grid card's own fast-add stepper, the cart drawer's own
        // line-item controls, main-collection-product-grid cards, quiz recommendations,
        // product-page related products, etc.) — only the featured-collections grid is a
        // genuine classic-vs-chat A/B surface ("classic"); everything else exists site-wide
        // regardless of experience ("shared"). Distinguish by whether the element that
        // triggered this mutation lives inside .featured_collections_wrapper.
        var __isFeaturedCollectionsGridMutation = !!(
          item.targetElement &&
          item.targetElement.closest &&
          item.targetElement.closest(".featured_collections_wrapper")
        );
        var __expSourceForLog = __isFeaturedCollectionsGridMutation ? "classic" : "shared"; // shared by the _experience_source_log write below and the GA4 product_added push
        // Section-level tracking (assets/wonderful-section-source-log.js): the exact same section_id already
        // rendered as data-section-id on the mutation's containing section (e.g. featured_collection_grid_<page>,
        // set in sections/featured-collections.liquid). Blank when the target isn't inside a known section
        // (cart drawer's own line-item controls, main-collection-product-grid, quiz recommendations, etc.) —
        // those stay untracked in _section_source_log rather than being logged with an invented id.
        var __sectionElForLog = item.targetElement && item.targetElement.closest
          ? item.targetElement.closest("[data-section-id]")
          : null;
        var __sectionIdForLog = __sectionElForLog ? __sectionElForLog.getAttribute("data-section-id") || "" : "";
        if (window.__WONDERFUL_CLASSIC_CART_PUSH_SKIP__) {
          // chat-cart visual mirror echo — the actual write already happened via the chat cart's own call.
        } else if (item.productId && window.WonderfulExperienceLog) {
          var __priorQtyForLog = 0;
          if (itemInCart != null) {
            var __qtyElForLog = itemInCart.querySelector(".item__image-count");
            __priorQtyForLog = __qtyElForLog ? (parseInt(__qtyElForLog.innerText, 10) || 0) : 0;
          }
          var __newQtyForLog = (item.productCount != null && item.productCount >= 0) ? item.productCount : 0;
          var __deltaForLog = __newQtyForLog - __priorQtyForLog;
          if (__deltaForLog !== 0) {
            window.WonderfulExperienceLog.recordDelta(item.productId, __deltaForLog, __expSourceForLog, __productLabelForLog);
            if (window.WonderfulSectionLog) {
              window.WonderfulSectionLog.recordDelta(item.productId, __deltaForLog, __sectionIdForLog, __productLabelForLog);
            }
          }
          if (__deltaForLog > 0 && window.WonderfulGA4) {
            var __unitPriceCentsForGa4 = parseInt(item.productUnitPriceWithoutСurrency, 10);
            if (isNaN(__unitPriceCentsForGa4)) {
              var __lineCentsForGa4 = parseInt(item.productPriceWithoutСurrency, 10);
              __unitPriceCentsForGa4 = (!isNaN(__lineCentsForGa4) && __newQtyForLog > 0)
                ? Math.round(__lineCentsForGa4 / __newQtyForLog)
                : NaN;
            }
            window.WonderfulGA4.pushProductAdded({
              experienceSource: __expSourceForLog,
              sectionId: __sectionIdForLog,
              variantId: item.productId,
              quantity: __deltaForLog,
              unitPrice: isNaN(__unitPriceCentsForGa4) ? NaN : __unitPriceCentsForGa4 / 100,
            });
          }
        }

        const IsQuizGridRecommendedProduct = [...itemInput].some(input => {
          const quizRecommendationCard = input.closest(".quiz-recommendations__card");
          const quizRecommendationCardsGrid = item.targetElement?.closest(".quiz-recommendations__cards");
          if (quizRecommendationCard && quizRecommendationCardsGrid) return true;
        });
      
        var isInputFieldInactiveAndZero = function (input) {
          return (
            input !== document.activeElement &&
            (input.value === "" || input.value <= 0)
          );
        };

        // grid item
        // itemInput = itemInput[0];
      
        // cart item
        // itemInput = itemInput[1];

        // console.log("Item input: ", itemInput);

        // Empty-qty blur is handled by bindQuantityDetectorInput → quantityCommitFromInput (do not stack blur listeners here).

        // console.log(item);
      
        if (itemInCart != null) {
          if (item.productCount != null && item.productCount >= 0) {
            let currentProductQuantity = parseInt(itemInCart.querySelector(".item__image-count").innerText);
            if (isNaN(currentProductQuantity)) currentProductQuantity = 0;

            if (!optimistic) {
              this.showCartLoaders();
              await this.changeCartItem(
                item.productId,
                item.productCount,
                "change",
                item.ajaxQuery
              );
              this.hideCartLoaders();
            }

            if (isStaleOptimisticMutation()) return;

            if (item.action == "update") {
              let newProductQuantity = parseInt(item.productCount);
              if (isNaN(newProductQuantity)) newProductQuantity = 0;

              if (currentProductQuantity > newProductQuantity && item.itemAnimation) {
                this.removeImageAnimation(item.productImage, item.originX, item.originY);
              } else if (currentProductQuantity < newProductQuantity) {
                this.addImageAnimation(item.productImage, item.originX, item.originY);

                if (IsQuizGridRecommendedProduct) trackQuizRecommendationAddToCart(item, currentProductQuantity);
              }
            }
      
            this.updateItemPrice(item);
            this.updateItemDrawerQty(item);
      
            if (item.productCount == 0) {
              // console.log("Removing from drawer - product count 0");
              this.removeFromDrawer(item);
            }
      
            if (item.action == "add") {
              this.addImageAnimation(item.productImage, item.originX, item.originY);

              if (IsQuizGridRecommendedProduct) trackQuizRecommendationAddToCart(item, currentProductQuantity);
            } else if (item.action == "remove") {
              this.removeImageAnimation(item.productImage, item.originX, item.originY);
            }
          } else {
            if (item.type !== "modal" || isInputFieldInactiveAndZero()) {
              // console.log("Removing from drawer - model or input field inactive");
              this.removeFromDrawer(item);
              this.removeImageAnimation(item.productImage, item.originX, item.originY);
            }
          }
        } else if (item.productCount > 0) {
          if (isStaleOptimisticMutation()) return;

          if (!optimistic) {
            this.showCartLoaders();
            await this.changeCartItem(
              item.productId,
              item.productCount,
              "add",
              item.ajaxQuery
            );
            this.hideCartLoaders();
          }

          if (IsQuizGridRecommendedProduct) trackQuizRecommendationAddToCart(item, 0);

          if (item.itemAnimation) {
            this.addImageAnimation(item.productImage, item.originX, item.originY);
          }
      
          itemsPlace.insertAdjacentHTML("afterbegin", newItem);
          initCartEvent(item);
        }

        if (isStaleOptimisticMutation()) return;
      
        this.updateCategories();
        this.updateSubtotalAndCartNumber();
        this.changeDrawerStatus();
        this.setInputValue(item);

        if (optimistic) {
          scheduleClassicDrawerShopifyPush(item.productId, item.productCount);
        } else {
          window.dispatchEvent(
            new CustomEvent("wonderful:classic-cart-item-updated", {
              detail: {
                variantId: String(item.productId || ""),
                quantity: Number(item.productCount) || 0,
              },
            })
          );
        }
      
        var addedItem = {
          productId: item.productId,
          productTitle: item.productTitle,
          productCategory: item.productCategory,
          productImage: item.productImage,
          productPrice: item.productPrice,
        };
      
        if (
          window.innerWidth > 1160 &&
          !this.checkDrawer() &&
          item.openCartDrawer
        ) {
          this.openDrawer();
      
          if (this.checkGrid()) {
            this.moveGridToLeft();
          }
        }

        function tryFireNormalOrderExpStart(item) {
          if (!item.targetElement || !item.targetElement.closest("#featured_collections")) return;
          try {
            if (sessionStorage.getItem("normal_order_exp_start_sent") === "1") return;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: "normal_order_exp_start" });
            sessionStorage.setItem("normal_order_exp_start_sent", "1");
          } catch (e) {}
        }
        tryFireNormalOrderExpStart(item);

        function trackQuizRecommendationAddToCart(item, currentProductQuantity) {
          const productName = item.productTitle;

          const productCategory = item.productCategory;

          const newProductCount = parseInt(item.productCount);
          const newTotalProductPrice = parseInt(item.productPrice.slice(1));
          const productPrice = newTotalProductPrice / newProductCount;

          const previousProductCount = currentProductQuantity;
          const addedProductCount = newProductCount - previousProductCount;

          const totalAddedProductPrice = addedProductCount * productPrice;

          // console.log("Recommended product added to cart: ", productName);
          // console.log("productName: ", productName);
          // console.log("productPrice: ", productPrice);
          // console.log("productCategory: ", productCategory);
          // console.log("addedProductCount: ", addedProductCount);
          // console.log("totalAddedProductPrice: ", totalAddedProductPrice);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'quizRecommendedProductsAddToCart',
              qr_product_name: productName,
              qr_product_price: productPrice,
              qr_product_category: productCategory,
              qr_product_added_count: addedProductCount,
              qr_total_added_product_price: totalAddedProductPrice
          });
        }
        } finally {
          if (!optimistic) this.awaitingAsyncAction = false;
        }
      },      
    },
    {
      key: "removeFromDrawer",
      value: function removeFromDrawer(item) {
        // console.log(item.removedFromDrawer);
        // if (item.removedFromDrawer) return;

        // searching the item by id and removing form cart drawer
        var itemInCart = this.drawer.querySelector(
          '.item__wrapper[data-id="'.concat(item.productId, '"]')
        );
        var productToZero = document.querySelector(
          '.product-card-grid-item .quantity-detector[data-id="'.concat(
            item.productId,
            '"]'
          )
        );
        if (productToZero) {
          productToZero.value = 0;
          productToZero.dataset.quantityCommitted = "0";
        }

        if (item.itemAnimation) {
          this.removeImageAnimation(item.productImage, item.originX, item.originY);
        }
        // console.log("ItemInCart: ", itemInCart);
        // console.log("Parent: ", itemInCart?.parentElement);
        if (itemInCart) {
          itemInCart?.remove(); // Remove the item from the cart
        }
      },
    },
    {
      key: "setInputValue",
      value: function setInputValue(item) {
        //itemInput with querySelectorAll -> gets both inputs of a product -> in grid and in the list view; in this way when one is changed, the another also takes this val
        var itemSelector = document.querySelector(
            'select.quantity-detector[data-id="'.concat(item.productId, '"]')
          ),
          itemInput = document.querySelectorAll(
            'input.quantity-detector[data-id="'.concat(item.productId, '"]')
          ),
          itemCount = document.querySelector(
            '.cart-drawer__cart-items .item__wrapper[data-id="'.concat(
              item.productId,
              '"] .item__image-count'
            )
          )?.innerText;
        if (
          item.type === "input" &&
          item.productCount != null &&
          item.productCount !== ""
        ) {
          itemCount = String(parseInt(String(item.productCount), 10) || 0);
        }
        if (typeof itemCount == "undefined") {
          itemCount = 0;
        }
        //when selected with querySelectorAll
        for (var i = 0; i < itemInput.length; i++) {
          itemInput[i].value = itemCount;
          itemInput[i].dataset.quantityCommitted = String(
            parseInt(itemCount, 10) || 0
          );
          var cartRow = itemInput[i].closest(".item__wrapper");
          if (
            cartRow &&
            cartRow.closest(".cart-drawer__cart-items")
          ) {
            var priceEl = cartRow.querySelector(".item__price");
            var lineC =
              priceEl && priceEl.dataset && priceEl.dataset.price != null
                ? parseInt(priceEl.dataset.price, 10) || 0
                : 0;
            var q = parseInt(itemCount, 10) || 0;
            if (q > 0 && lineC > 0) {
              var unit = Math.round(lineC / q);
              itemInput[i].dataset.unitPrice = String(unit);
              itemInput[i].dataset.price = String(unit);
            }
          }
        }
        //when selected 1 element querySelector
        //itemInput.value = itemCount;

        try {
          if (itemSelector) {
            itemSelector.selectedIndex = parseInt(itemCount);
          }
        } catch (error) {
          console.error(error);
        }
      },
    },
    {
      key: "removeImageAnimation",
      value: function removeImageAnimation(
        image,
        itemHandleOrOriginX = null,
        originXOrY,
        originYArg
      ) {
        var itemHandle = null;
        var originX = null;
        var originY = null;

        if (typeof itemHandleOrOriginX === "string") {
          itemHandle = itemHandleOrOriginX;
          originX = originXOrY;
          originY = originYArg;
        } else {
          originX = itemHandleOrOriginX;
          originY = originXOrY;
        }
        /*
      var currentElement = document.querySelector("[data-img=\"".concat(image, "\"]:not(.btn-detector)")).parentElement.parentElement;
        if(currentElement.parentElement.parentElement.classList.contains('cart-grid-view')){
        currentElement = currentElement.parentElement        
          }  
      */

        if (itemHandle != null) {
          var currentElement = $(
            '[data-handle="'.concat(itemHandle, '"]:visible:not(.btn-detector)')
          ).closest(".card-product");
        }

        var currentElement = $(
          '[data-img="'.concat(image, '"]:visible:not(.btn-detector)')
        ).closest(".card-product");

        // match the item by handle if it's not found by image and if handle is provided
        if (currentElement.length === 0 && itemHandle != null) {
          var currentElement = $(
            '[data-handle="'.concat(itemHandle, '"]:visible:not(.btn-detector)')
          ).closest(".card-product");
        }

        currentElement = currentElement.find("input.quantity-detector");
        currentElement = currentElement.get(0);

        if (
          !currentElement &&
          (typeof originX !== "number" || typeof originY !== "number")
        ) {
          return;
        }

        var cartIcon = document.querySelector("#cartDrawer");
        if (!cartIcon) return;

        var currentElementTop = currentElement
            ? window.innerWidth > 1024
              ? currentElement.getBoundingClientRect().top + 10
              : currentElement.getBoundingClientRect().top + 5
            : originY,
          currentElementLeft = currentElement
            ? window.innerWidth > 1024
              ? currentElement.getBoundingClientRect().left + 10
              : currentElement.getBoundingClientRect().left
            : originX,
          cartIconTop = cartIcon.getBoundingClientRect().top,
          // add optional
          cartIconLeft = cartIcon.getBoundingClientRect().left,
          imgElement = document.createElement("img"),
          indentificator = Math.floor(Math.random() * 100000);
        if (
          typeof currentElementTop !== "number" ||
          typeof currentElementLeft !== "number"
        ) {
          return;
        }
        imgElement.src = image;
        imgElement.classList.add("floating-image-".concat(indentificator));
        imgElement.style.cssText = "top: 0; left: ".concat(cartIconLeft, "px;");
        document.querySelector("body").appendChild(imgElement);
        var floatingImage = document.querySelector(
          ".floating-image-".concat(indentificator)
        );
        setTimeout(function () {
          floatingImage.style.cssText = "top: "
            .concat(currentElementTop, "px; left: ")
            .concat(currentElementLeft, "px;");
        }, 1);
        setTimeout(function () {
          floatingImage.style.transform = "scale(0)";
        }, 800);
        setTimeout(function () {
          floatingImage.remove();
        }, 1000);
      },
    },
    {
      key: "addImageAnimation",
      value: function addImageAnimation(image, originX, originY) {
        /*
      var currentElement = document.querySelector("[data-img=\"".concat(image, "\"]:not(.btn-detector)")).parentElement.parentElement;
      if(currentElement.parentElement.parentElement.classList.contains('cart-grid-view')){
        currentElement = currentElement.parentElement        
      }
      */
        var currentElement = $(
          '[data-img="'.concat(image, '"]:visible:not(.btn-detector)')
        ).closest(".card-product");
        currentElement = currentElement.find("input.quantity-detector");
        currentElement = currentElement.get(0);

        var cartIcon = document.querySelector("#cartDrawer");
        if (!cartIcon) return;

        var currentElementTop = currentElement
            ? currentElement.getBoundingClientRect().top
            : originY,
          currentElementLeft = currentElement
            ? currentElement.getBoundingClientRect().left
            : originX,
          cartIconTop = cartIcon.getBoundingClientRect().top,
          cartIconLeft = cartIcon.getBoundingClientRect().left,
          imgElement = document.createElement("img"),
          indentificator = Math.floor(Math.random() * 100000);

        if (
          typeof currentElementTop !== "number" ||
          typeof currentElementLeft !== "number"
        ) {
          return;
        }
        imgElement.src = image;
        imgElement.classList.add("floating-image-".concat(indentificator));
        imgElement.style.cssText = "top: "
          .concat(currentElementTop, "px; left: ")
          .concat(currentElementLeft, "px;");
        document.querySelector("body").appendChild(imgElement);
        var floatingImage = document.querySelector(
          ".floating-image-".concat(indentificator)
        );
        setTimeout(function () {
          floatingImage.style.cssText = "top: 0; left: ".concat(
            cartIconLeft,
            "px;"
          );
        }, 1);
        setTimeout(function () {
          floatingImage.style.transform = "scale(0)";
        }, 800);
        setTimeout(function () {
          floatingImage.remove();
        }, 1000);
      },
    },
    {
      key: "updateCategories",
      value: function updateCategories() {
        var _this = this;

        var currentCatElement = this.drawer.querySelectorAll(".item__wrapper"),
          categoriesValue = this.drawer.querySelectorAll(".cat-value"); // resetting all values for preventing adding new values to old

        categoriesValue.forEach(function (element) {
          if (isNaN(element.innerText)) {
            element.innerText = 0;
          } else {
            element.innerText = 0; // This line doesn't change the value, consider revising it.
          }
        }); // getting each cart item, checking for an item category, adding a count of items to the category counter

        currentCatElement.forEach(function (element) {
          var elementCategory = element.dataset.category,
            categorElement = _this.drawer.querySelector(
              '.cat-value[data-cat="'.concat(elementCategory, '"]')
            ),
            qtyElement = element.querySelector(".item__image-count"),
            elementQty = qtyElement ? parseInt(qtyElement.innerText) : 0;

          if (!categorElement) return;
          if (!isNaN(elementQty)) {
            categorElement.innerText =
              parseInt(categorElement.innerText) + elementQty;
          }
        });
      },
    },
    {
      key: "updateItemPrice",
      value: function updateItemPrice(item) {
        // searching the item by id and changing a price
        var itemInCart = this.drawer.querySelector(
          '.item__wrapper[data-id="'.concat(item.productId, '"]')
        );

        if (item.type === "modal") {
          var currentPrice =
            itemInCart.querySelector(".item__price").dataset.price;
          itemInCart.querySelector(".item__price").dataset.price =
            parseInt(currentPrice) + parseInt(item.productPriceWithoutСurrency);
          itemInCart.querySelector(".item__price").innerText = this.formatMoney(
            parseInt(currentPrice) + parseInt(item.productPriceWithoutСurrency)
          );
        } else {
          itemInCart.querySelector(".item__price").dataset.price =
            item.productPriceWithoutСurrency;
          itemInCart.querySelector(".item__price").innerText =
            item.productPrice;
          var priceTextEl = itemInCart.querySelector(".item__price_text");
          if (priceTextEl) {
            var lineParsed =
              parseInt(
                String(itemInCart.querySelector(".item__price").dataset.price),
                10
              ) || 0;
            var qtyParsed = parseInt(String(item.productCount), 10) || 0;
            var unitParsed =
              qtyParsed > 0 ? Math.round(lineParsed / qtyParsed) : lineParsed;
            var unitLabel = this.formatMoney(unitParsed).replace(".00", "");
            priceTextEl.innerHTML = "\u00a0x " + unitLabel + " =";
          }
        }
      },
    },
    {
      key: "updateItemDrawerQty",
      value: function updateItemDrawerQty(item) {
        // searching the item by id and changing a tag text
        var itemInCart = this.drawer.querySelector(
          '.item__wrapper[data-id="'.concat(item.productId, '"]')
        );

        if (item.type === "modal") {
          var currentQty =
            itemInCart.querySelector(".item__image-count").innerText;
          itemInCart.querySelector(".item__image-count").innerText =
            parseInt(currentQty) + parseInt(item.productCount);
        } else {
          itemInCart.querySelector(".item__image-count").innerText =
            item.productCount;
        }
      },
    },
    {
      key: "updateSubtotalAndCartNumber",
      value: function updateSubtotalAndCartNumber() {
        var _this = this;
        var cartItemsCount = 0,
          cartSubtotal = 0;
        var cartItems = this.drawer.querySelectorAll(".item__wrapper"); // calculation cart items count and subtotal

        cartItems.forEach(function (element) {
          var qtyEl = element.querySelector(".item__image-count");
          var elementQty = qtyEl
            ? parseInt(qtyEl.innerText, 10) || 0
            : 0;
          var priceEl = element.querySelector(".item__price");
          var lineCents = 0;
          if (priceEl && priceEl.dataset && priceEl.dataset.price != null) {
            lineCents = parseInt(priceEl.dataset.price, 10) || 0;
          }
          cartItemsCount += elementQty;
          cartSubtotal += lineCents;
          if (priceEl) {
            priceEl.innerText = _this.formatMoney(lineCents);
          }
        }); // searching for header bubble with cart items count and set a new value

        var cartNumber = document.querySelector("#cartDrawer .cart-number");
        cartNumber.classList.remove("hide");
        cartNumber.innerText = cartItemsCount;
        if (cartItemsCount === 0 || isNaN(cartItemsCount)) {
          cartNumber.classList.add("hide");
        } else {
          cartNumber.classList.remove("hide");
        } // searching for subtotal price value and set a new value

        // console.log(cartSubtotal);
        this.drawer.querySelector("#subtotal-value").innerText =
          this.formatMoney(cartSubtotal);
        this.drawer.querySelector("#subtotal-value-top").innerText =
          this.formatMoney(cartSubtotal);

        var FREE_SHIP_CENTS = 25000;
        var pct =
          cartSubtotal >= FREE_SHIP_CENTS
            ? 100
            : Math.min(
                100,
                Math.floor((cartSubtotal / FREE_SHIP_CENTS) * 100)
              );
        var unlocked = cartSubtotal >= FREE_SHIP_CENTS;
        var labelText = unlocked
          ? "FREE SHIPPING UNLOCKED!"
          : "FREE SHIPPING FOR ORDERS $250+";
        this.drawer
          .querySelectorAll(".cart-drawer__free-shipping-banner__fill")
          .forEach(function (el) {
            el.style.width = pct + "%";
          });
        this.drawer
          .querySelectorAll(".cart-drawer__free-shipping-banner__label")
          .forEach(function (el) {
            el.textContent = labelText;
          });
      },
    },
    {
      key: "changeCartItem",
      value: 
      // function changeCartItem(itemId, itemQty, action) {
      //   var ajaxQuery =
      //     arguments.length > 3 && arguments[3] !== undefined
      //       ? arguments[3]
      //       : true;

      //   if (ajaxQuery) {
      //     $.ajax({
      //       type: "POST",
      //       url: "/cart/".concat(action, ".js"),
      //       data: {
      //         quantity: itemQty,
      //         id: itemId,
      //       },
      //       dataType: "json",
      //       success: function(response) {
      //         console.log("Success:", response);
      //         // Handle successful response
      //         this.updateCategories();
      //         this.updateSubtotalAndCartNumber();
      //         this.changeDrawerStatus();
      //       }.bind(this),
      //       error: function(xhr, status, error) {
      //         console.error("Error:", error);
      //         // Handle error response
      //       },
      //       complete: function(xhr, status) {
      //         console.log("Request completed");
      //         // Perform actions after completion, if needed
      //       }
      //     });
      //   }

      //   // this.updateCategories();
      //   // this.updateSubtotalAndCartNumber();
      //   // this.changeDrawerStatus();

      //   // document
      //   //   .querySelectorAll("input.quantity-detector")
      //   //   .forEach(function (element) {
      //   //     element.addEventListener("input", function () {
      //   //       var item = {
      //   //         productTitle: element.dataset.name,
      //   //         productHandle: element.dataset.handle,
      //   //         productId: element.dataset.id,
      //   //         productCount: element.value,
      //   //         productLink: element.dataset.link,
      //   //         productImage: element.dataset.img,
      //   //         productPriceWithoutСurrency:
      //   //           parseInt(element.dataset.price) * parseInt(element.value),
      //   //         productPrice: cartDrawer.formatMoney(
      //   //           parseInt(element.dataset.price) * parseInt(element.value)
      //   //         ),
      //   //         productPriceWithoutZero: cartDrawer
      //   //           .formatMoney(
      //   //             parseInt(element.dataset.price) * parseInt(element.value)
      //   //           )
      //   //           .replace(".00", ""),
      //   //         productCategory: element.dataset.category,
      //   //         type: "input",
      //   //         itemAnimation: true,
      //   //         openCartDrawer: true,
      //   //         ajaxQuery: true,
      //   //         productDataColor: element.dataset.color,
      //   //         productDataTitle: element.dataset.title,
      //   //         productDataDesc: element.dataset.desc,
      //   //       };
      //   //       cartDrawer.addToDrawer(item);
      //   //     });
      //   //   });
      // },
      function changeCartItem(itemId, itemQty, action, ajaxQuery = true) {
        let queryData;
        if (this.isMonthlySubscriptionActive) {
          queryData = { quantity: itemQty, id: itemId, selling_plan: this.SELLING_PLAN_ID };
        } else {
          queryData = { quantity: itemQty, id: itemId };
        }

        if (ajaxQuery) {
          // /cart/add.js and /cart/change.js don't document support for cart-level
          // `attributes`, unlike /cart/update.js — so the source-log write for this
          // direct path is a small parallel request rather than piggybacked here.
          if (window.WonderfulExperienceLog) {
            window.WonderfulExperienceLog.getPendingAttributesPatch()
              .then(function (patch) {
                if (!patch) return;
                fetch("/cart/update.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  credentials: "same-origin",
                  body: JSON.stringify({ attributes: patch }),
                })
                  .then(function (res) {
                    if (res.ok) window.WonderfulExperienceLog.markFlushed();
                  })
                  .catch(function () {});
              })
              .catch(function () {});
          }
          return new Promise((resolve, reject) => {
            $.ajax({
              type: "POST",
              url: `/cart/${action}.js`,
              data: queryData,
              dataType: "json",
              success: function(response) {
                resolve(response);
              },
              error: function(xhr, status, error) {
                reject(error);
              },
            });
          });
        } else {
          this.updateCategories();
          this.updateSubtotalAndCartNumber();
          this.changeDrawerStatus();
          return Promise.resolve();
        }
      },
    },
    {
      key: "renderTemplateData",
      value: function renderTemplateData(item, replceData) {
        var data = {};
        for (var copyKey in replceData) {
          data[copyKey] = replceData[copyKey];
        }
        var lineStr = String(
          data.productPriceWithoutСurrency != null
            ? data.productPriceWithoutСurrency
            : "0"
        ).replace(/[^\d-]/g, "");
        var lineVal = parseInt(lineStr, 10);
        if (isNaN(lineVal)) lineVal = 0;
        var countVal = parseInt(String(data.productCount || "0"), 10);
        if (isNaN(countVal)) countVal = 0;
        if (
          (data.productUnitPriceWithoutСurrency === undefined ||
            data.productUnitPriceWithoutСurrency === null ||
            data.productUnitPriceWithoutСurrency === "") &&
          countVal > 0 &&
          lineVal > 0
        ) {
          data.productUnitPriceWithoutСurrency = String(
            Math.round(lineVal / countVal)
          );
        } else if (
          (!data.productUnitPriceWithoutСurrency ||
            data.productUnitPriceWithoutСurrency === "") &&
          lineVal > 0 &&
          countVal === 0
        ) {
          data.productUnitPriceWithoutСurrency = String(lineVal);
        }

        if (
          (!data.productUnitPriceWithoutZero ||
            data.productUnitPriceWithoutZero === "") &&
          data.productUnitPriceWithoutСurrency
        ) {
          var __uc = parseInt(
            String(data.productUnitPriceWithoutСurrency).replace(/[^\d-]/g, ""),
            10
          );
          if (!isNaN(__uc) && __uc > 0) {
            data.productUnitPriceWithoutZero = this.formatMoney(__uc).replace(
              ".00",
              ""
            );
          }
        }

        for (var dataKey in data) {
          var length = item.includes("!{ ".concat(dataKey, " }"));

          if (!String(data[dataKey]).includes("!")) {
            do {
              item = item.replace("!{ ".concat(dataKey, " }"), data[dataKey]);
              length = item.includes("!{ ".concat(dataKey, " }"));
            } while (length);
          }
        }

        return item;
      },
    },
    {
      key: "moveGridToLeft",
      value: function moveGridToLeft() {
        //if (window.innerWidth < 1480) {
        //this.grid.querySelectorAll('.page-width')[0].animate([{'marginLeft': '0'},{'marginLeft': '0px!important'}],500);
        //}
      },
    },
    {
      key: "moveGridToRight",
      value: function moveGridToRight() {
        this.grid
          .querySelectorAll(".page-width")[0]
          .animate({ marginLeft: "auto" }, 500);
      },
    },
    {
      key: "formatMoney",
      value: function formatMoney(cents, format) {
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || "${{amount}}";

        function defaultOption(opt, def) {
          return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split("."),
            dollars = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands
            ),
            cents = parts[1] ? decimal + parts[1] : "";

          return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      },
    },
  ]);

  return CartDrawer;
})();

var cartDrawer = new CartDrawer(
  "#cart-drawer__wrapper",
  "#cart-item-template",
  "#shopify-section-cart-template-grid",
  ".cart-template-list",
  ".grid-select",
  ".list-select"
);

window.wonderfulClassicCartAdd = function (item) {
  if (!item || !item.productId) return;

  var qty = parseInt(item.productCount, 10);
  if (isNaN(qty)) qty = 1;

  var rawPrice = parseInt(item.productPriceWithoutСurrency, 10);
  if (isNaN(rawPrice)) rawPrice = 0;

  var normalized = Object.assign(
    {
      action: qty > 0 ? "add" : "remove",
      productCount: qty,
      productPriceWithoutСurrency: rawPrice,
      productPrice: cartDrawer.formatMoney(rawPrice),
      productPriceWithoutZero: cartDrawer.formatMoney(rawPrice).replace(".00", ""),
      productTitle: "",
      productCategory: "",
      productImage: "",
      productLink: "",
      productHandle: "",
      itemAnimation: true,
      openCartDrawer: true,
      ajaxQuery: CLASSIC_CART_AJAX_QUERY_DEFAULT,
      type: "input",
      targetElement: null,
      productDataColor: "",
      productDataTitle: "",
      productDataDesc: "",
    },
    item
  );

  var __lineC = parseInt(String(normalized.productPriceWithoutСurrency), 10) || 0;
  var __qtyN = parseInt(String(normalized.productCount), 10) || 0;
  var __unitC = __qtyN > 0 ? Math.round(__lineC / __qtyN) : __lineC;
  normalized.productUnitPriceWithoutСurrency = String(__unitC);
  normalized.productUnitPriceWithoutZero = cartDrawer
    .formatMoney(__unitC)
    .replace(".00", "");

  cartDrawer.addToDrawer(normalized);
};
window.__WONDERFUL_CLASSIC_CART_EVENT_READY__ = true;
window.addEventListener("wonderful:sync-classic-cart", function (event) {
  var detail = event && event.detail ? event.detail : null;
  if (!detail || !detail.productId) return;
  window.wonderfulClassicCartAdd(detail);
});
cartDrawer.updateCategories();
document.querySelector("#cartDrawer").addEventListener("click", function (e) {
  e.preventDefault();
  cartDrawer.changeDrawerStatus();
  cartDrawer.openDrawer();
});
document
  .querySelectorAll("#x-mark-drawer, #cart-drawer__overlay")
  .forEach(function (element) {
    element.addEventListener("click", function () {
      cartDrawer.closeDrawer();
    });
  });
document
  .getElementById("clear-cart-items")
  .addEventListener("click", function (e) {
    var items = gatherInfoAboutRemovingItems();

    // This button wipes the drawer + POSTs /cart/clear.js directly, bypassing
    // addToDrawer entirely, AND clears every line item regardless of source
    // (including chat-added ones) — so wipe the whole log rather than trying
    // to reconstruct per-variant pops from whatever happens to be rendered
    // in the drawer DOM at click time (that can miss out-of-sync variants).
    if (window.WonderfulExperienceLog) {
      window.WonderfulExperienceLog.clearAll();
    }

    cartDrawer.drawer
      .querySelectorAll(".item__wrapper")
      .forEach(function (element) {
        element.remove();
      });
    document.querySelectorAll("input.quantity-detector").forEach(function (element) {
      element.value = 0;
      element.dataset.quantityCommitted = "0";
    });
    document.querySelectorAll("select.quantity-detector").forEach(function (element) {
      element.value = 0;
    });
    document.querySelectorAll('.no-spin[class^="qty-detector"]').forEach(function (element) {
      element.value = 1;
    });

    cartDrawer.changeDrawerStatus();
    cartDrawer.updateSubtotalAndCartNumber();
    cartDrawer.closeDrawer();
    playRemoveItemsAnimations(items);

    window.dispatchEvent(
      new CustomEvent("wonderful:classic-cart-cleared", {
        detail: { source: "classic-cart-drawer" },
      })
    );

    fetch("/cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).catch(function () {});

    // /cart/clear.js doesn't accept attributes, so flush the cleared log separately.
    if (window.WonderfulExperienceLog) {
      window.WonderfulExperienceLog.getPendingAttributesPatch().then(function (patch) {
        if (!patch) return;
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ attributes: patch }),
        })
          .then(function (res) {
            if (res.ok) window.WonderfulExperienceLog.markFlushed();
          })
          .catch(function () {});
      });
    }
  });

function gatherInfoAboutRemovingItems() {
  var cartItemsContainer = cartDrawer.drawer.querySelector(".cart-drawer__cart-items");
  var cartItems = cartItemsContainer.querySelectorAll(".item__wrapper");
  var items = [];

  cartItems.forEach(function (element) {
    var itemHandle = element.dataset.item;

    var img = element.querySelector(".item__image img");
    var ImgSrc = img.src.replace("https:", "");

    items.push({
      handle: itemHandle,
      imgSrc: ImgSrc,
    });
  });

  return items;
}

function playRemoveItemsAnimations(items) {
  items.forEach(function (item) {
    cartDrawer.removeImageAnimation(item.imgSrc, item.handle);
  });

}

window.addEventListener("DOMContentLoaded", async () => {
  /* Check if the monthly subscription is active */
  await cartDrawer.setMonthlySubscriptionState();

  /* Update the monthly subscription state over time */
  updateMonthlySubscriptionState(cartDrawer);

  /* Added | Select grid view by default */
  cartDrawer.openGrid();

  /* Change drawer status on page load */
  cartDrawer.changeDrawerStatus();
});

/* Remove unavailable products from the cart on page load */
window.addEventListener("DOMContentLoaded", () => {
  var cartItems = document.querySelectorAll(".item__wrapper");

  cartItems.forEach(function (item) {
    var itemSoldOut = item.dataset.soldOut;

    if (itemSoldOut === "true") {
      removeItemFromCart(item);
    }
  });
});

/* Open the cart drawer if the page is Cart */
window.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname === "/cart" && window.innerWidth > 1280) {
    cartDrawer.openDrawer();
  }
});

if (document.querySelectorAll(".grid-select").length > 0) {
  document
    .querySelectorAll(".grid-select")[0]
    .addEventListener("click", function () {
      this.classList.add("active-button");
      cartDrawer.openGrid();
      document
        .querySelectorAll(".list-select")[0]
        .classList.remove("active-button");
    });
} //endif

if (document.querySelectorAll(".list-select").length > 0) {
  document
    .querySelectorAll(".list-select")[0]
    .addEventListener("click", function () {
      this.classList.add("active-button");
      cartDrawer.openList();
      document
        .querySelectorAll(".grid-select")[0]
        .classList.remove("active-button");
    });
} //endif

function wonderfulQuantityNormalize(element) {
  var raw = parseInt(element.value, 10);
  if (isNaN(raw) || raw < 0) raw = 0;
  element.value = raw;
  return raw;
}

/** Unit price in cents: prefer data-unit-price; else data-price as unit (never infer line÷qty by divisibility — unit cents are often divisible by qty). */
function wonderfulDeriveUnitPriceCents(element) {
  if (!element || !element.dataset) return 0;
  var explicit = parseInt(element.dataset.unitPrice, 10);
  if (Number.isFinite(explicit) && explicit > 0) return explicit;
  return parseInt(element.dataset.price, 10) || 0;
}

function wonderfulQuantityBuildItem(element) {
  var qty = wonderfulQuantityNormalize(element);
  var unitPrice = wonderfulDeriveUnitPriceCents(element);
  var lineCents = unitPrice * qty;
  return {
    action: "update",
    targetElement: element,
    productTitle: element.dataset.name,
    productHandle: element.dataset.handle,
    productId: element.dataset.id,
    productCount: String(qty),
    productLink: element.dataset.link,
    productImage: element.dataset.img,
    productPriceWithoutСurrency: lineCents,
    productPrice: cartDrawer.formatMoney(lineCents),
    productPriceWithoutZero: cartDrawer
      .formatMoney(lineCents)
      .replace(".00", ""),
    productUnitPriceWithoutZero: cartDrawer
      .formatMoney(unitPrice)
      .replace(".00", ""),
    productCategory: element.dataset.category,
    type: "input",
    itemAnimation: true,
    openCartDrawer: true,
    ajaxQuery: CLASSIC_CART_AJAX_QUERY_DEFAULT,
    productDataColor: element.dataset.color,
    productDataTitle: element.dataset.title,
    productDataDesc: element.dataset.desc,
    productUnitPriceWithoutСurrency: String(unitPrice),
  };
}

function commitDrawerQtyFromInput(inp, overrides) {
  if (!inp || !inp.dataset) return;
  var newQty = wonderfulQuantityNormalize(inp);
  var prev = inp.dataset.quantityCommitted;
  if (prev !== undefined && String(newQty) === prev) return;
  inp.dataset.quantityCommitted = String(newQty);
  var item = wonderfulQuantityBuildItem(inp);
  if (overrides) {
    for (var key in overrides) {
      if (Object.prototype.hasOwnProperty.call(overrides, key)) {
        item[key] = overrides[key];
      }
    }
  }
  cartDrawer.addToDrawer(item);
}

function quantityCommitFromInput(element) {
  commitDrawerQtyFromInput(element);
}

function quantityRevertInput(element) {
  if (!element || !element.dataset) return;
  var v =
    element.dataset.quantityCommitted !== undefined
      ? element.dataset.quantityCommitted
      : "0";
  element.value = v;
}

function bindQuantityDetectorInput(element) {
  if (!element || element.dataset.wonderfulQtyBound === "1") return;
  element.dataset.wonderfulQtyBound = "1";
  if (element.dataset.quantityCommitted === undefined) {
    element.dataset.quantityCommitted = String(
      parseInt(element.value, 10) || 0
    );
  }
  element.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      wonderfulQuantityNormalize(element);
      element.blur();
    } else if (e.key === "Escape") {
      e.preventDefault();
      quantityRevertInput(element);
      element.blur();
    }
  });
  element.addEventListener("blur", function () {
    quantityCommitFromInput(element);
  });
}

window.wonderfulBindQuantityDetectorInput = bindQuantityDetectorInput;

document
  .querySelectorAll("input.quantity-detector")
  .forEach(function (element) {
    bindQuantityDetectorInput(element);
  });

function quantityOnClick(e) {
  e.preventDefault();
  var element = e.target;
  var holder = element.closest(".input__number-holder");
  var inputElement = holder
    ? holder.querySelectorAll("input.quantity-detector")
    : [];
  var inp = inputElement[0];

  if (element.classList.contains("minus")) {
    if (inp && inp.value >= 1) {
      inp.value && inp.value--;
    } else if (inp) {
      inp.value && (inp.value = 0);
    }
  } else if (element.classList.contains("plus")) {
    if (inp) inp.value && inp.value++;
  }

  if (inp !== undefined) {
    commitDrawerQtyFromInput(inp, {
      targetElement: element,
      itemAnimation: true,
      openCartDrawer: true,
    });
  }
}

function removeItemFromCart(itemWrapper) {
  var inputElement = itemWrapper.querySelectorAll("input.quantity-detector");

  if (inputElement[0] !== undefined) {
    var inp = inputElement[0];
    inp.value = 0;
    commitDrawerQtyFromInput(inp, {
      itemAnimation: false,
      openCartDrawer: false,
    });
  }
}

document.querySelectorAll(".input__number-holder").forEach(function (element) {
  var clickElement = element.querySelectorAll(".qty");

  clickElement.forEach(function (element) {
    element.addEventListener("click", quantityOnClick);
  });
});

document
  .querySelectorAll("select.quantity-detector")
  .forEach(function (element) {
    element.dataset.quantityPrev = element.value;
    element.addEventListener("focus", function () {
      element.dataset.quantityPrev = element.value;
    });
    element.addEventListener("change", function () {
      var selectedOption = element.options[element.selectedIndex];
      var unitCents = wonderfulDeriveUnitPriceCents(element);
      var newQty = parseInt(selectedOption.value, 10) || 0;
      var lineCents = unitCents * newQty;
      element.dataset.quantityPrev = String(newQty);
      var item = {
        targetElement: element,
        productTitle: element.dataset.name,
        productHandle: element.dataset.handle,
        productId: element.dataset.id,
        productCount: String(newQty),
        productLink: element.dataset.link,
        productImage: element.dataset.img,
        productPriceWithoutСurrency: lineCents,
        productPrice: cartDrawer.formatMoney(lineCents),
        productPriceWithoutZero: cartDrawer
          .formatMoney(lineCents)
          .replace(".00", ""),
        productUnitPriceWithoutZero: cartDrawer
          .formatMoney(unitCents)
          .replace(".00", ""),
        productCategory: element.dataset.category,
        type: "selector",
        itemAnimation: true,
        openCartDrawer: true,
        ajaxQuery: CLASSIC_CART_AJAX_QUERY_DEFAULT,
        productDataColor: element.dataset.color,
        productDataTitle: element.dataset.title,
        productDataDesc: element.dataset.desc,
        productUnitPriceWithoutСurrency: String(unitCents),
      };
      cartDrawer.addToDrawer(item);
    });
  });

function initCartEvent(curr_item) {
  document
    .querySelectorAll(
      '.item__wrapper[data-id="' +
        curr_item.productId +
        '"] input.quantity-detector'
    )
    .forEach(function (element) {
      bindQuantityDetectorInput(element);
    });

  document
    .querySelectorAll(
      '.item__wrapper[data-id="' +
        curr_item.productId +
        '"] .input__number-holder'
    )
    .forEach(function (holder) {
      if (holder.dataset.wonderfulQtyStepBound === "1") return;
      holder.dataset.wonderfulQtyStepBound = "1";
      var clickElement = holder.querySelectorAll(".qty");
      var inputElement = holder.querySelectorAll("input.quantity-detector");

      clickElement.forEach(function (qtyBtn) {
        qtyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          var inp = inputElement[0];

          if (qtyBtn.classList.contains("minus")) {
            if (inp && inp.value >= 1) {
              inp.value && inp.value--;
            } else if (inp) {
              inp.value && (inp.value = 0);
            }
          } else if (qtyBtn.classList.contains("plus")) {
            if (inp) inp.value && inp.value++;
          }

          if (inp !== undefined) {
            commitDrawerQtyFromInput(inp, {
              targetElement: e.target,
              itemAnimation: true,
              openCartDrawer: true,
            });
          }
        });
      });
    });

  document
    .querySelectorAll(
      '.item__wrapper[data-id="' +
        curr_item.productId +
        '"] select.quantity-detector'
    )
    .forEach(function (element) {
      element.dataset.quantityPrev = element.value;
      element.addEventListener("focus", function () {
        element.dataset.quantityPrev = element.value;
      });
      element.addEventListener("change", function () {
        var selectedOption = element.options[element.selectedIndex];
        var unitCents = wonderfulDeriveUnitPriceCents(element);
        var newQty = parseInt(selectedOption.value, 10) || 0;
        var lineCents = unitCents * newQty;
        element.dataset.quantityPrev = String(newQty);
        var item = {
          targetElement: element,
          productTitle: element.dataset.name,
          productHandle: element.dataset.handle,
          productId: element.dataset.id,
          productCount: String(newQty),
          productLink: element.dataset.link,
          productImage: element.dataset.img,
          productPriceWithoutСurrency: lineCents,
          productPrice: cartDrawer.formatMoney(lineCents),
          productPriceWithoutZero: cartDrawer
            .formatMoney(lineCents)
            .replace(".00", ""),
          productUnitPriceWithoutZero: cartDrawer
            .formatMoney(unitCents)
            .replace(".00", ""),
          productCategory: element.dataset.category,
          type: "selector",
          itemAnimation: true,
          openCartDrawer: true,
          ajaxQuery: CLASSIC_CART_AJAX_QUERY_DEFAULT,
          productDataColor: element.dataset.color,
          productDataTitle: element.dataset.title,
          productDataDesc: element.dataset.desc,
          productUnitPriceWithoutСurrency: String(unitCents),
        };
        cartDrawer.addToDrawer(item);
      });
    });

  // document.querySelectorAll('.item__wrapper[data-id="'+curr_item.productId+'"] #clear-cart-item').forEach(itemRemoveElement => {
  //   if(itemRemoveElement) {
  //     itemRemoveElement.addEventListener('click', function(e) {
  //       e.preventDefault();
  //       const item = e.target.closest('.item__wrapper');
  //       const qtyPicker = item.querySelector('input.quantity-detector');
  //       if(qtyPicker) {
  //         qtyPicker.value = 0;
  //         qtyPicker.dispatchEvent(new Event('input'));
  //       }
  //     });
  //   }
  // });
}

document.querySelectorAll("#clear-cart-item").forEach((itemRemoveElement) => {
  if (itemRemoveElement) {
    itemRemoveElement.addEventListener("click", function (e) {
      e.preventDefault();
      const item = e.target.closest(".item__wrapper");
      const qtyPicker = item.querySelector("input.quantity-detector");
      if (qtyPicker) {
        qtyPicker.value = 0;
        qtyPicker.dataset.quantityCommitted = "0";
        cartDrawer.addToDrawer(wonderfulQuantityBuildItem(qtyPicker));
      }
    });
  }
});

// function clear_cart_item(ele) {
//   const item = ele.closest('.item__wrapper');
//   const qtyPicker = item.querySelector('input.quantity-detector');
//   if(qtyPicker) {
//     qtyPicker.value = 0;
//     qtyPicker.dispatchEvent(new Event('input'));
//   }
// }
function clear_cart_item(ele) {
  const item = ele.closest(".item__wrapper");
  const qtyPicker = item.querySelector("input.quantity-detector");
  if (qtyPicker) {
    qtyPicker.value = 0;
    qtyPicker.dataset.quantityCommitted = "0";
    cartDrawer.addToDrawer(wonderfulQuantityBuildItem(qtyPicker));
  }
  // if (item) {
  //   item.remove();
  //   this.removeImageAnimation(item.productImage);
  // }
  cartDrawer.updateCategories();
  cartDrawer.updateSubtotalAndCartNumber();
  cartDrawer.changeDrawerStatus();
}

function updateMonthlySubscriptionState(cartDrawer) {
  const subscriptionCheckboxes = document.querySelectorAll(".make-monthly-order-checkbox");

  subscriptionCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("change", () => {
      cartDrawer.isMonthlySubscriptionActive = !cartDrawer.isMonthlySubscriptionActive;
    });
  });
}

async function allItemsAreMonthly() {
  const cartResponse = await fetch('/cart.js');
  const cartData = await cartResponse.json();

  if (cartData.items.length === 0) {
    return false;
  }
  
  return cartData.items.every(item => item.selling_plan_allocation != null);
}

window.addEventListener("pagehide", function() {
  try {
    sessionStorage.removeItem("normal_order_exp_start_sent");
  } catch (e) {}
});

/* Browsers restore this page from bfcache (no server round-trip) when the
 * shopper hits Back from /checkout, leaving the cart drawer showing whatever
 * it rendered before they left. Force a real reload so the Liquid-rendered
 * drawer, subtotal, and cart count reflect the current cart. */
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

function pushNormalOrderExpCheckout() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "normal_order_exp_checkout" });
}

document.addEventListener("DOMContentLoaded", function() {
  var checkoutDrawerLoaderActive = false;

  function showCheckoutDrawerLoader() {
    if (checkoutDrawerLoaderActive) return false;
    checkoutDrawerLoaderActive = true;
    var loader = document.querySelector("[data-animated-cart-loader]");
    var caption = loader && loader.querySelector(".loader__loading-caption");
    if (caption && loader && !loader.dataset.checkoutOriginalCaption) {
      loader.dataset.checkoutOriginalCaption = caption.textContent || "";
      caption.textContent = "Loading";
    }
    showCartLoaders();
    return true;
  }

  function hideCheckoutDrawerLoader() {
    if (!checkoutDrawerLoaderActive) return;
    checkoutDrawerLoaderActive = false;
    var loader = document.querySelector("[data-animated-cart-loader]");
    if (!loader) return;
    var caption = loader.querySelector(".loader__loading-caption");
    if (caption && loader.dataset.checkoutOriginalCaption != null) {
      caption.textContent = loader.dataset.checkoutOriginalCaption;
      delete loader.dataset.checkoutOriginalCaption;
    }
    hideCartLoaders();
  }

  function goToCheckoutAfterReconcile(onReady) {
    if (
      window.__WONDERFUL_SESSION_CART_SYNC__ &&
      typeof window.__WONDERFUL_RECONCILE_CHECKOUT__ === "function"
    ) {
      window
        .__WONDERFUL_RECONCILE_CHECKOUT__()
        .then(function () {
          onReady();
        })
        .catch(function () {
          hideCheckoutDrawerLoader();
        });
      return;
    }
    onReady();
  }

  function bindClassicCheckoutLinks(selector) {
    document.querySelectorAll(selector).forEach(function(link) {
      if (link.dataset.wonderfulCheckoutBound === "1") return;
      link.dataset.wonderfulCheckoutBound = "1";
      link.addEventListener("click", function(e) {
        e.preventDefault();
        if (!showCheckoutDrawerLoader()) return;
        pushNormalOrderExpCheckout();
        goToCheckoutAfterReconcile(function() {
          if (
            window.checkoutExperience &&
            typeof window.checkoutExperience.setClassicAndGoToCheckout === "function"
          ) {
            window.checkoutExperience.setClassicAndGoToCheckout();
          } else {
            window.location.href = "/checkout";
          }
        });
      });
    });
  }
  bindClassicCheckoutLinks('#cart-drawer__wrapper a[href="/checkout"]');
  bindClassicCheckoutLinks('a[data-goto-precheckout][href="/checkout"]');
});